/* ==========================================================================
   bj-plp.js — Bella Jane collection pages (16 Oct 2026; metal price 19 Oct)
   Markup: sections/main-collection.liquid + snippets/bj-plp-card.liquid.
   The theme's filters re-render #CollectionProductGrid by replacing HTML,
   so everything here is delegated from `document`.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bjPlpInit) return;
  window.__bjPlpInit = true;

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* --- quick links: bring the current collection into view ------------------ */
  function initChips() {
    var tracks = document.querySelectorAll('[data-bjc-chips]');
    for (var i = 0; i < tracks.length; i++) {
      var on = tracks[i].querySelector('.is-on');
      if (on && tracks[i].scrollWidth > tracks[i].clientWidth) {
        tracks[i].scrollLeft = Math.max(0, on.offsetLeft - (tracks[i].clientWidth - on.offsetWidth) / 2);
      }
    }
  }

  /* --- metal swatches swap the photo and the link, no page load ------------ */
  function pickSwatch(sw) {
    var card = closest(sw, '[data-bjc-card]');
    if (!card) return;
    var all = card.querySelectorAll('[data-bjc-sw]');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === sw);
    var track = card.querySelector('[data-bjc-track]');
    if (track && track.scrollLeft) track.scrollTo({ left: 0, behavior: 'instant' });
    var src = sw.getAttribute('data-img');
    var img = card.querySelector('[data-bjc-img]');
    if (img && src) {
      img.removeAttribute('srcset'); // srcset would win over the new src
      img.src = src;
    }
    var url = sw.getAttribute('data-url');
    if (url) {
      var links = card.querySelectorAll('[data-bjc-link]');
      for (var j = 0; j < links.length; j++) links[j].setAttribute('href', url);
    }
    // Metal pages only (19 Oct): the price follows the metal in the photo.
    // data-price is the card's own Liquid output (bj-plp-price), not user input.
    var price = sw.getAttribute('data-price');
    var priceEl = card.querySelector('[data-bjc-price]');
    if (price && priceEl) priceEl.innerHTML = price;
    // Metal pages only (19 Oct): swipe photos 2–3 follow the metal too.
    // Slides not swiped yet just get new data-src (nothing downloads until a
    // swipe); slides already showing switch straight away.
    var extra = sw.getAttribute('data-extra');
    if (extra) {
      var urls = extra.split('|');
      var slides = card.querySelectorAll('[data-bjc-track] .bjc-card__img');
      for (var k = 1; k < slides.length && k <= urls.length; k++) {
        var u = urls[k - 1];
        var set = u.replace('width=540', 'width=360') + ' 360w, ' + u + ' 540w, ' + u.replace('width=540', 'width=720') + ' 720w';
        var el = slides[k];
        if (el.hasAttribute('data-bjc-lazy')) {
          el.setAttribute('data-src', u);
          el.setAttribute('data-srcset', set);
        } else {
          el.setAttribute('srcset', set);
          el.setAttribute('src', u);
        }
      }
    }
  }

  /* --- photo strip: load photos 2–3 on first swipe, keep the dots in step -- */
  function wake(track) {
    if (!track || track.getAttribute('data-bjc-awake')) return;
    track.setAttribute('data-bjc-awake', '1');
    var lazy = track.querySelectorAll('[data-bjc-lazy]');
    for (var i = 0; i < lazy.length; i++) {
      var im = lazy[i];
      if (im.getAttribute('data-srcset')) im.setAttribute('srcset', im.getAttribute('data-srcset'));
      if (im.getAttribute('data-src')) im.setAttribute('src', im.getAttribute('data-src'));
      im.removeAttribute('data-bjc-lazy');
    }
  }
  function syncDots(track) {
    var media = closest(track, '.bjc-card__media');
    var dots = media && media.querySelectorAll('[data-bjc-dots] i');
    if (!dots || !dots.length || !track.clientWidth) return;
    var n = Math.round(track.scrollLeft / track.clientWidth);
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === n);
  }
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-bjc-track')) {
        wake(t);
        syncDots(t);
      }
    },
    true // scroll doesn't bubble
  );
  // A finger on the strip: start loading before the swipe lands.
  document.addEventListener(
    'touchstart',
    function (e) {
      wake(closest(e.target, '[data-bjc-track]'));
    },
    { passive: true }
  );
  // Desktop: hovering a photo shows the second one.
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var media = closest(e.target, '.bjc-card__media');
      if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
      var track = media.querySelector('[data-bjc-track]');
      if (!track || track.children.length < 2) return;
      wake(track);
      track.scrollTo({ left: track.clientWidth, behavior: 'instant' });
    });
    document.addEventListener('mouseout', function (e) {
      var media = closest(e.target, '.bjc-card__media');
      if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
      var track = media.querySelector('[data-bjc-track]');
      if (track) track.scrollTo({ left: 0, behavior: 'instant' });
    });
  }

  /* --- "Show more": append the next page's products ------------------------ */
  // Remembers how many pages were shown, so Back from a product brings the
  // shopper to the same place (NN/g; Baymard) even when the browser didn't
  // keep the page in memory.
  function stateKey() {
    return 'bjc:' + location.pathname + location.search; // filters change the URL
  }
  function readState() {
    try { return JSON.parse(sessionStorage.getItem(stateKey()) || 'null'); } catch (e) { return null; }
  }
  function writeState(patch) {
    try {
      var st = readState() || { pages: 1, y: 0 };
      for (var k in patch) st[k] = patch[k];
      sessionStorage.setItem(stateKey(), JSON.stringify(st));
    } catch (e) {}
  }
  function showMore(btn, quiet) {
    var href = btn.getAttribute('href');
    var grid = document.getElementById('main-collection-product-grid');
    var wrap = closest(btn, '[data-bjc-more-wrap]');
    if (!href || !grid || !wrap) {
      window.location.href = href;
      return Promise.resolve(false);
    }
    var label = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Loading…';
    return fetch(href, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('page ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('main-collection-product-grid');
        var nextWrap = doc.querySelector('[data-bjc-more-wrap]');
        if (!nextGrid) throw new Error('no grid');
        var first = null;
        while (nextGrid.firstElementChild) {
          var node = document.importNode(nextGrid.firstElementChild, true);
          nextGrid.removeChild(nextGrid.firstElementChild);
          grid.appendChild(node);
          if (!first) first = node;
        }
        if (nextWrap) {
          // Keep "Previous page" off: everything is on one page now.
          var prev = nextWrap.querySelector('.bjc-more__prev');
          if (prev) prev.parentNode.removeChild(prev);
          wrap.parentNode.replaceChild(document.importNode(nextWrap, true), wrap);
        } else {
          wrap.parentNode.removeChild(wrap);
        }
        var st = readState();
        writeState({ pages: ((st && st.pages) || 1) + 1 });
        // Screen readers and keyboards land on the first new piece.
        var link = first && first.querySelector('.bjc-card__name');
        if (link && !quiet) {
          try { link.focus({ preventScroll: true }); } catch (e) {}
        }
        return true;
      })
      .catch(function () {
        // Leave a working button behind (Back-restore runs quietly and must not
        // strand "Loading…" if the fetch fails).
        btn.classList.remove('is-loading');
        btn.textContent = label;
        if (!quiet) window.location.href = href;
        return false;
      });
  }

  // Back from a product page: reload the same number of pages, then return
  // to the same spot. A fresh visit starts at the top.
  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var type = nav ? nav.type : '';
    var st = readState();
    if (type !== 'back_forward') {
      try { sessionStorage.removeItem(stateKey()); } catch (e) {}
      return;
    }
    if (!st) return;
    var want = st.pages || 1;
    var y = st.y || 0;
    writeState({ pages: 1 });
    (function step(done) {
      var btn = document.querySelector('[data-bjc-more]');
      if (done >= want || !btn) {
        if (y) window.scrollTo(0, y);
        return;
      }
      showMore(btn, true).then(function (ok) {
        if (ok) step(done + 1);
      });
    })(1);
  }
  window.addEventListener('pagehide', function () {
    if (document.getElementById('main-collection-product-grid')) writeState({ y: window.pageYOffset || 0 });
  });

  document.addEventListener('click', function (e) {
    var sw = closest(e.target, '[data-bjc-sw]');
    if (sw) {
      e.preventDefault();
      pickSwatch(sw);
      return;
    }
    var more = closest(e.target, '[data-bjc-more]');
    if (more) {
      e.preventDefault();
      showMore(more);
    }
  });

  function boot() {
    initChips();
    restore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
